<template>
  <section>
    <template v-for="(item, index) in qlist">
      <div
        :key="index"
        v-if="item.title_num === curQ && !allHideList.includes(item.title_num)"
        class="multipage-container"
      >
        <div class="q-header">
          <span class="curr">{{ curQ }}</span>
          <span class="total">/{{ qlist.length }}</span>
        </div>
        <div class="content-wrap">
          <component
            class="q-item"
            :index="index"
            :titleNo="item.title_num"
            :isRequired="item.is_required === 1"
            :question="item"
            :is="compsMap[item.subject_type]"
            @change="handleChange"
            pageType="multi"
          ></component>
        </div>
        <div class="footer">
          <div class="btn prev" v-if="curQ !== 1" @click="changePrev">
            上一题
          </div>
          <div
            :class="['btn', { disabled: isNoCanNext }]"
            v-if="!isEnd"
            @click="changeNext"
          >
            下一题
          </div>
          <div
            :class="['btn', { disabled: isNoCanNext }]"
            v-if="isEnd"
            @click="handleMultiSubmit"
          >
            提交
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
/**
 * 多页问卷
 */
import QuestionMixin from './mixin/question-mixin.js';
export default {
  name: 'MultiPageQuestion',
  // 此页面逻辑全部交由mixin处理
  mixins: [QuestionMixin],
  data() {
    return {
      curQ: 1, // 当前题目编号
    };
  },
  computed: {
    // 是否可以进行下一题
    isNoCanNext: (vm) => {
      const index = vm.curQ - 1;
      const item = vm.answer_json[index] || {};
      // 此方法来自mixin
      const title_num = vm.checkItemIsPass(item, index);
      return !!title_num;
    },
    // 结束==>提交按钮展示
    isEnd: (vm) => {
      // 只要是最后一题，就可以提交
      // allHideList逻辑已经覆盖提前结束、正常结束(没答完题)的场景了
      for (let index = vm.qlist.length - 1; index >= 0; index--) {
        const title_num = vm.qlist[index]?.title_num;
        if (vm.allHideList.includes(title_num)) {
          continue;
        }
        return vm.curQ === title_num;
      }
    },
  },
  mounted() {},
  methods: {
    // 切换题目-上一题
    changePrev() {
      // 当前题目索引
      const curQIndex = this.qlist.findIndex((item) => {
        return item.title_num === this.curQ;
      });
      // 上一题逻辑
      for (let i = curQIndex - 1; i >= 0; i--) {
        const title_num = this.qlist[i].title_num;
        if (!this.allHideList.includes(title_num)) {
          this.curQ = title_num;
          return;
        }
      }
    },
    // 下一题
    changeNext() {
      if (this.isNoCanNext) return;

      const curQIndex = this.qlist.findIndex((item) => {
        return item.title_num === this.curQ;
      });

      for (let i = curQIndex + 1; i < this.qlist.length; i++) {
        const title_num = this.qlist[i].title_num;
        if (!this.allHideList.includes(title_num)) {
          this.curQ = title_num;
          return;
        }
      }
      // this.$hll.toast('提前结束');
    },
    handleMultiSubmit() {
      if (!this.isNoCanNext) {
        this.handleSubmit();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.multipage-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .q-header {
    padding-top: 18px;
    padding-bottom: 10px;
    .curr {
      font-size: 30px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
    .total {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .content-wrap {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .footer {
    box-shadow: 0px -2px 4px 1px rgba(0, 0, 0, 0.02);
    padding: 0 8px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 34px;
    .btn {
      flex: 1;
      margin: 0 6px;
      height: 44px;
      line-height: 44px;
      background: #f16622;
      border-radius: 8px;
      color: #fff;
      font-size: 18px;
      text-align: center;
      outline: none;
      box-sizing: border-box;
      &.prev {
        background: transparent;
        border: 1px solid #f60;
        color: #f60;
      }
      &.disabled {
        background: rgba(255, 102, 0, 0.5);
      }
    }
  }
}
</style>
